import { render } from "./PostEvent.view.vue?vue&type=template&id=20371cc0"
import script from "./PostEvent.view.vue?vue&type=script&lang=js"
export * from "./PostEvent.view.vue?vue&type=script&lang=js"

import "./PostEvent.view.vue?vue&type=style&index=0&id=20371cc0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__